import { Router } from '@angular/router';

export type CatalogosHubTab = 'clientes' | 'proveedores' | 'vehiculos';
export type ConfiguracionHubTab = 'usuarios' | 'sat' | 'sistema';
export type EspacioHubTab = 'perfil' | 'actividad' | 'torre';

export function navigateToCatalogos(router: Router, tab: CatalogosHubTab): void {
  router.navigate(['/catalogos'], { queryParams: { tab } });
}

export function navigateToConfiguracion(router: Router, tab: ConfiguracionHubTab): void {
  router.navigate(['/configuracion'], { queryParams: { tab } });
}

export function navigateToEspacio(router: Router, tab: EspacioHubTab): void {
  router.navigate(['/espacio'], { queryParams: { tab } });
}

/** Prefijos de URL que pertenecen a cada ítem del menú (para routerLinkActive en drill-in). */
export function isMovimientosNavActive(url: string): boolean {
  return (
    url.startsWith('/movimientos') ||
    url.startsWith('/movimientos-pendientes') ||
    url.startsWith('/facturas')
  );
}

export function isCatalogosNavActive(url: string): boolean {
  return (
    url.startsWith('/catalogos') ||
    url.startsWith('/clientes') ||
    url.startsWith('/proveedores') ||
    url.startsWith('/vehiculos')
  );
}

export function isConfiguracionNavActive(url: string): boolean {
  return (
    url.startsWith('/configuracion') ||
    url.startsWith('/usuarios') ||
    url.startsWith('/sat')
  );
}

export function isEspacioNavActive(url: string): boolean {
  return (
    url.startsWith('/espacio') ||
    url.startsWith('/perfil') ||
    url.startsWith('/feed') ||
    url.startsWith('/torre')
  );
}
